import { render, staticRenderFns } from "./CountrySettingSideMenu.vue?vue&type=template&id=4acd3d24"
import script from "./CountrySettingSideMenu.vue?vue&type=script&lang=js"
export * from "./CountrySettingSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4acd3d24')) {
      api.createRecord('4acd3d24', component.options)
    } else {
      api.reload('4acd3d24', component.options)
    }
    module.hot.accept("./CountrySettingSideMenu.vue?vue&type=template&id=4acd3d24", function () {
      api.rerender('4acd3d24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/countrysetting/CountrySettingSideMenu.vue"
export default component.exports